import React from "react";
import { ApolloClient, ApolloProvider, InMemoryCache } from '@apollo/client';
import { BrowserRouter } from "react-router-dom";
import MainContainer from "./React/MainContainer.js";
import "./App.css";

import { HttpLink } from 'apollo-link-http';
import { ApolloLink } from 'apollo-link';

const httpLink = new HttpLink({
    uri: "/graphql",
});
  
export const middleware = new ApolloLink((operation, forward) => {
    const session = localStorage.getItem("woo-session");

    if (session) {
        operation.setContext(({ headers = {} }) => ({
            headers: {
                "woocommerce-session": `Session ${session}`
            }
        }));
    }

    return forward(operation);
});
  
export const afterware = new ApolloLink((operation, forward) => {
    return forward(operation).map((response) => {
        const context = operation.getContext();
        const { response: { headers } } = context;
        const session = headers.get("woocommerce-session");

        if (session) {
            if (localStorage.getItem("woo-session") !== session) {
                localStorage.setItem('woo-session', headers.get("woocommerce-session"));
            }

            var expires = new Date();
            expires.setDate(expires.getDate() + 30);

            document.cookie = "encrypted_customer_session=" + session + ";expires=" + expires.toGMTString() + ";path=/";
        }
        
        return response;
    });
});

export const client = new ApolloClient({
    link: middleware.concat(afterware.concat(httpLink)),
    cache: new InMemoryCache()
});

function App() {
    return <ApolloProvider client={client}>
        <BrowserRouter>
            <MainContainer />
        </BrowserRouter>
    </ApolloProvider>
}

export default App;